import './Button.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "root": "Button_root__j2zr8",
    "disabled": "Button_disabled__j2zr8",
    "block": "Button_block__j2zr8",
    "primary": "Button_primary__j2zr8",
    "secondary": "Button_secondary__j2zr8",
    "ghost": "Button_ghost__j2zr8",
    "small": "Button_small__j2zr8",
    "medium": "Button_medium__j2zr8",
    "defaultSize": "Button_defaultSize__j2zr8",
    "large": "Button_large__j2zr8"
};
